import React, {Component} from "react";
import "./Hero.css";

import Logo from "Logo/Logo";
import HeroNavigation from "./HeroNavigation/HeroNavigation";
import ScrollIndicator from "ScrollIndicator/ScrollIndicator";
import Portrait from "./Portrait/Portrait";
import Particles from "./Particles/Particles";

import utils from "utils";
//import heroImage from "./hero.jpg";
const heroImage = "";

export default class Hero extends Component
{
	render()
	{
		const imagePaths = ["react.png", "nodejs.png", "csharp.png", "php.png"];
		const images = imagePaths.map((path, i) =>
		{
			return <img key={i} src={utils.getAsset("icons/" + path)} alt="" />;
		});

		return (
			<div ref={this.props.handleRef} className="hero" style={{backgroundImage: "url(" + heroImage + ")"}}>
				<div className="overlay">
					<div className="top">
						<div className="wrapper">
							<Logo />
							<HeroNavigation scrollToSection={this.props.scrollToSection} />
						</div>
					</div>

					<div className="center">
						<h1 className="title">Andrew Guterman</h1>

						<div className="anim-wrapper">
							<h3 className="subtitle">{"<Full Stack Developer/>"}</h3>

							<div className="images">
								{images}
							</div>
						</div>

						<Particles />
					</div>

					<div className="bottom">
						<ScrollIndicator onClick={this.props.onScrollClick} />
					</div>

					{/*<Portrait />*/}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Hero/Hero.js